import { helpers, pr, React, theme, ui, observer, config, api } from "aaa";
import { Loan } from "models/Loan";
import { numberToPercentageString, numberToCurrencyStringShort, numberToCurrencyString } from "util/helpers";



export const RepresentativeExample = observer((props: {
    interestSet?: api.IInterestSet,
    style?: React.CSSProperties,
}) => {

    if (!props.interestSet) {
        return null;
    }

    const examples = props.interestSet.repExes;
    const amount = examples[0].amount;
    const duration1 = examples[0].durationInYears;
    const duration2 = examples[1].durationInYears;

    const percentage = (value: number) => numberToPercentageString(value) + " p.a.";

    return (
        <div style={props.style}>
            <pr.TextH3 style={{ width: "80%", maxWidth: 600 }}>
                {ui.__("representativeExample", { amount: helpers.numberToCurrencyString(amount) })}
            </pr.TextH3>
            <br />
            <div>
                <table>
                    <thead>
                        <tr>
                            <th>{ui.__("representativeExample.header.duration")}</th>
                            <th>{ui.__("representativeExample.header.duration.example", { duration: duration1 })}</th>
                            <th>{ui.__("representativeExample.header.duration.example", { duration: duration2 })}</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>{ui.__("representativeExample.payOut")}</td>
                            <td>{numberToPercentageString(examples[0].payOut)}</td>
                            <td>{numberToPercentageString(examples[1].payOut)}</td>
                        </tr>
                        <tr>
                            <td>{ui.__("representativeExample.initial")}</td>
                            <td>{numberToPercentageString(examples[0].initialAmortization)}</td>
                            <td>{numberToPercentageString(examples[1].initialAmortization)}</td>
                        </tr>
                        <tr>
                            <td>{ui.__("representativeExample.interest")}</td>
                            <td>{numberToPercentageString(examples[0].interest)}</td>
                            <td>{numberToPercentageString(examples[1].interest)}</td>
                        </tr>
                        <tr>
                            <td>{ui.__("representativeExample.interestEffective")}</td>
                            <td>{numberToPercentageString(examples[0].interestEffective)}</td>
                            <td>{numberToPercentageString(examples[1].interestEffective)}</td>
                        </tr>
                        <tr>
                            <td>{ui.__("representativeExample.monthlyRate")}</td>
                            <td>{numberToCurrencyString(examples[0].monthlyRate, true, true)}</td>
                            <td>{numberToCurrencyString(examples[1].monthlyRate, true, true)}</td>
                        </tr>
                        <tr>
                            <td>{ui.__("representativeExample.numRates")}</td>
                            <td>{examples[0].numRates}</td>
                            <td>{examples[1].numRates}</td>
                        </tr>
                        <tr>
                            <td>{ui.__("loan.durationInYears")}</td>
                            <td>{examples[0].durationInYears}</td>
                            <td>{examples[1].durationInYears}</td>
                        </tr>
                        <tr>
                            <td>{ui.__("representativeExample.total")}</td>
                            <td>{numberToCurrencyString(examples[0].total, true, true)}</td>
                            <td>{numberToCurrencyString(examples[1].total, true, true)}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    );
});


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/RepresentativeExample.tsx